// extracted by mini-css-extract-plugin
var _1 = "#000000";
var _2 = "#76F366";
var _3 = "#EB8632";
var _4 = "#ECC834";
var _5 = "#21FC87";
var _6 = "#EA4A30";
var _7 = "#C7EA45";
var _8 = "#272B2B";
var _9 = "#BDBDBD";
var _a = "#7D7D7D";
var _b = "#6A0DAD";
var _c = "#3A65FF";
var _d = "#4A90E2";
var _e = "#ffffff";
var _f = "1200px";
var _10 = "992px";
var _11 = "1366px";
var _12 = "768px";
var _13 = "1475px";
var _14 = "576px";
var _15 = "1600px";
var _16 = "320px";
var _17 = "2500px";
export { _1 as "colorBlack", _2 as "colorGradeEX", _3 as "colorGradeFR", _4 as "colorGradeGD", _5 as "colorGradeOU", _6 as "colorGradePR", _7 as "colorGradeVG", _8 as "colorNeutral", _9 as "colorNeutralLighest", _a as "colorNeutralLight", _b as "colorNonOwnerSweetLine", _c as "colorOwnerSweetLine", _d as "colorRegularLinks", _e as "colorWhite", _f as "screenlg", _10 as "screenmd", _11 as "screenml", _12 as "screensm", _13 as "screenxlg", _14 as "screenxs", _15 as "screenxxlg", _16 as "screenxxs", _17 as "screenxxxlg" }
export default { "colorBlack": _1, "colorGradeEX": _2, "colorGradeFR": _3, "colorGradeGD": _4, "colorGradeOU": _5, "colorGradePR": _6, "colorGradeVG": _7, "colorNeutral": _8, "colorNeutralLighest": _9, "colorNeutralLight": _a, "colorNonOwnerSweetLine": _b, "colorOwnerSweetLine": _c, "colorRegularLinks": _d, "colorWhite": _e, "screenlg": _f, "screenmd": _10, "screenml": _11, "screensm": _12, "screenxlg": _13, "screenxs": _14, "screenxxlg": _15, "screenxxs": _16, "screenxxxlg": _17 }
